/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramGeoControllerGetDistrictsQueryResponse,
  TelegramGeoControllerGetDistrictsPathParams,
} from '../types/TelegramGeoControllerGetDistricts.ts';

function getTelegramGeoGetDistrictsUrl(cityId: TelegramGeoControllerGetDistrictsPathParams['cityId']) {
  const res = { method: 'GET', url: `/api/telegram/geo/districts/${cityId}` as const };
  return res;
}

/**
 * {@link /api/telegram/geo/districts/:cityId}
 */
export async function telegramGeoGetDistricts(
  cityId: TelegramGeoControllerGetDistrictsPathParams['cityId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramGeoControllerGetDistrictsQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramGeoGetDistrictsUrl(cityId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
